import axios from 'axios';
//
// Base configuration for axios
//https://localhost:44346/api
const apiClient = axios.create({
  //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.truvey.in/api',
 // baseURL: process.env.REACT_APP_API_BASE_URL || 'https://localhost:44346/api',
   baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.xprssurvey.com/api', // Replace with your API base URL
  //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://xprssurveyapi.demoo4s.com/api', // Replace with your API base URL

  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Service methods
const apiService = {
  Userlogin: async (email, password, ip, Device) => {
    try {
      const response = await apiClient.post('/Login/ValidateUser', { email, password, ip, Device });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },

  EncryptJWT: async (token) => {
    try {
      const response = await apiClient.post('/Login/GetUserDetails', { token });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  // Fetch survey Details
  GetSurveyDetails: async (Token) => {
    const response = await apiClient.post('/Survey/SurveyDetails', { Token });
    return response.data;
  },
  // Fetch user profile
  GetQuestionDetails: async (Token, SurveyUID) => {
    const response = await apiClient.post('/Survey/SurveyQuestions', { Token, SurveyUID });
    return response.data;
  },
  // Create a new survey
  createSurvey: async (submitFormData) => {
    const response = await apiClient.post('/Survey/CreateSurvey', submitFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  },
  // Get Access For Survey
  GetAccess: async (Token, SurveyUID) => {
    const response = await apiClient.post('/Survey/SurveyData', { Token, SurveyUID });
    return response.data;
  },
  // update survey
  UpdateSurvey: async (submitFormData) => {
    const response = await apiClient.post('/Survey/UpdateSurvey', submitFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
  PublishSurvey: async (Token, SurveyUID, SurveyStartDateTime, SurveyEndDateTime, SurveyThankYouNote) => {
    const response = await apiClient.post('/Survey/ScheduleSurvey', { Token, SurveyUID, SurveyStartDateTime, SurveyEndDateTime, SurveyThankYouNote });
    return response.data;
  },
  ChangeStatus: async (Token, SurveyUID) => {
    const response = await apiClient.post('/Survey/ChangeSurveyStatus', { Token, SurveyUID });
    return response.data;
  },
  DeleteSurvey: async (Token, SurveyUID) => {
    const response = await apiClient.post('/Survey/DeleteSurvey', { Token, SurveyUID });
    return response.data;
  },
  GetPermissionData: async (Token, SurveyUID) => {
    try {
      const response = await apiClient.post('/Survey/PermissionData', { Token, SurveyUID });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  DeletePermission: async (Token, SurveyUID, SurveyID) => {
    try {
      const response = await apiClient.post('/Survey/DeletePermission', { Token, SurveyUID, SurveyID });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  CreatePermission: async (Token, SurveyUID, Email, CanEdit, CanEnd) => {
    try {
      const response = await apiClient.post('/Survey/CreatePermission', {
        Token,
        SurveyUID,
        Email,
        CanEdit,
        CanEnd
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  UpdatePermission: async (Token, SurveyUID, SurveyID, Email, CanEdit, CanEnd) => {
    try {
      const response = await apiClient.post('/Survey/UpdatePermission', {
        Token,
        SurveyUID,
        SurveyID,
        Email,
        CanEdit,
        CanEnd
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  CreateResponders: async (payload) => {
    debugger
    try {
      const response = await apiClient.post('/Survey/CreateResponders',
        payload
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  CreateReminder: async (Token, SurveyUID, EmailSubject, EmailBody, SurveyStartDateTime, SendTo) => {
    debugger
    try {
      const response = await apiClient.post('/Survey/CreateReminder',
        { Token, SurveyUID, EmailSubject, EmailBody, SurveyStartDateTime, SendTo }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  RegisterUser: async (Name, email, MobileNo, Password) => {
    try {
      const response = await apiClient.post('/Login/CreateUser',
        { Name, email, MobileNo, Password }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  VerifyRegisterUser: async (Name, email, OTP) => {
    try {
      const response = await apiClient.post('/Login/VerifyRegistration',
        { Name, email, OTP }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  GetUserData: async (Token) => {
    try {
      const response = await apiClient.post('/Survey/GetProfileData',
        { Token }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  CreateOrUpdateEmailDetails: async (Token, SendByEmail, EmailPassword, PortNumber) => {
    try {
      const response = await apiClient.post('/Survey/AddOrUpdateEmailDetails',
        { Token, SendByEmail, EmailPassword, PortNumber }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  UpdateProfileData: async (UserName,
    UserMobileNumber,
    Gender,
    UserCity,
    PinCode,
    UserState,
    UserCountry,
    UserAddress,
    SocialMedia,
    Token) => {
    try {
      const response = await apiClient.post('/Survey/UpdateProfileData',
        {
          UserName,
          UserMobileNumber,
          Gender,
          UserCity,
          PinCode,
          UserState,
          UserCountry,
          UserAddress,
          SocialMedia,
          Token
        }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  UpdateProfileImage: async (ProfileImgData) => {

    const response = await apiClient.post('/Survey/UpdateProfileImage', ProfileImgData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  },
  ManageSurveyQuestions: async (payload) => {

    const response = await apiClient.post('/Survey/ManageSurveyQuestions', payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  },
  ResetPassword: async (Email, MobileNo) => {
    try {
      const response = await apiClient.post('/Login/ResetPassword',
        { Email, MobileNo }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  VerifyResetOTP: async (RequestID, OTP, Password) => {
    try {
      const response = await apiClient.post('/Login/VerifyResetOTP',
        { RequestID, OTP, Password }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  EndSurvey: async (Token, SurveyUID) => {
    try {
      const response = await apiClient.post('/Survey/EndSurvey',
        { Token, SurveyUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  GetSurveyReminders: async (Token, SurveyUID) => {
    try {
      const response = await apiClient.post('/Survey/GetSurveyReminders',
        { Token, SurveyUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  GetSurveyResponders: async (Token, SurveyUID) => {
    try {
      const response = await apiClient.post('/Survey/GetSurveyResponders',
        { Token, SurveyUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  GetSurveyResponseRate: async (Token) => {
    try {
      const response = await apiClient.post('/Survey/GetSurveyResponseRate',
        { Token }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  GetPlanDetailsUser: async (Token) => {
    try {
      const response = await apiClient.post('/Login/GetPlanDetailsUser',
        { Token }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  VerifyActivationCode: async (ActivationKey) => {
    try {
      const response = await apiClient.post('/Login/VerifyActivationCode',
        { ActivationKey }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
      return { STATUS: "ERROR", RESPONSE: "Request failed" };
    }
  },
  CompleteActivation: async (ActivationKey, Password) => {
    try {
      const response = await apiClient.post('/Login/CompleteAccountActivation',
        { ActivationKey, Password }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
      return { STATUS: "ERROR", RESPONSE: "Request failed" };
    }
  },
  GetUserProfileData: async (Token) => {
    try {
      const response = await apiClient.post('/Survey/GetProfileData',
        { Token }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  },
  CopySurvey: async (Token, SurveyUID) => {
    try {
      const response = await apiClient.post('/Survey/CopySurvey',
        { Token, SurveyUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  },
};

export default apiService;
